import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容频道',
    links: [
      { label: '电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv' },
      { label: '苹果视频', to: '/category/apple' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '版权声明', to: '/about' },
      { label: '联系反馈', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <Link to="/" className="mb-4 inline-flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-black text-background-50">
                苹果视频
              </span>
            </Link>
            <p className="max-w-md text-sm leading-relaxed text-background-300">
              苹果视频是一个聚合优质影视资源与苹果品牌相关视频内容的展示平台，涵盖电影、电视剧及苹果新品介绍、评测与教程，为用户提供便捷的浏览、筛选与观看体验。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="mb-4 text-sm font-bold text-background-50">
                {column.title}
              </h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-700/40 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-400">
            © 2026 苹果视频 Apple Video. 本站为演示性质内容平台，所有影视与产品资料均为示例内容。
          </p>
          <p className="text-xs text-background-400">
            本平台不提供真实视频播放源，仅作界面与交互展示。
          </p>
        </div>
      </div>
    </footer>
  );
}